import { Geografi } from '../../domain'

export const OSLO_FYLKE = '03'
export const OSLO_KOMMUNE = '03/0301'

export function getParentKey(geografi: Geografi) {
  if (geografi.key === '') {
    return null
  } else if (geografi.key === OSLO_FYLKE) {
    // Oslo fylke should not be a part of the hierarchy
    return null
  } else {
    if (geografi.key === OSLO_KOMMUNE) {
      // Oslo kommune should link directly to Norge
      return ''
    } else if (geografi.bydel) {
      return geografi.bydel.key
    } else if (geografi.parent) {
      return geografi.parent.key
    } else {
      throw Error('Klarte ikke å finne geografi.parent')
    }
  }
}
